import { render, staticRenderFns } from "./applicantDetail.vue?vue&type=template&id=042c01ce&scoped=true"
import script from "./applicantDetail.vue?vue&type=script&lang=js"
export * from "./applicantDetail.vue?vue&type=script&lang=js"
import style0 from "./applicantDetail.vue?vue&type=style&index=0&id=042c01ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c01ce",
  null
  
)

export default component.exports